// Stable named-id sentinel for the default Rovo Chat agent. Shared here so packages that cannot
// depend on `@atlassian/conversation-assistant` (the app) can still reference the canonical value.
export const DEFAULT_AGENT_NAMED_ID = 'ai_mate_agent';
